import { api } from "@/lib/api";

const QKEY = "jjl_offline_queue";
const PKEY = (bid) => `jjl_cache_products_${bid}`;
const BKEY = "jjl_cache_branch";

export const isOnline = () => (typeof navigator !== "undefined" ? navigator.onLine : true);

export function getQueue() { try { return JSON.parse(localStorage.getItem(QKEY) || "[]"); } catch { return []; } }
function setQueue(q) { localStorage.setItem(QKEY, JSON.stringify(q)); }
export function enqueue(payload) { const q = getQueue(); q.push(payload); setQueue(q); return q.length; }
export const queueCount = () => getQueue().length;

export function cacheBranch(b) { if (b) localStorage.setItem(BKEY, JSON.stringify(b)); }
export function getCachedBranch() { try { return JSON.parse(localStorage.getItem(BKEY) || "null"); } catch { return null; } }
export function cacheProducts(bid, products) { if (bid) localStorage.setItem(PKEY(bid), JSON.stringify(products || [])); }
export function getCachedProducts(bid) { try { return JSON.parse(localStorage.getItem(PKEY(bid)) || "[]"); } catch { return []; } }

// Replays queued offline checkouts. Server is idempotent via offline_id.
export async function syncQueue() {
  const q = getQueue();
  if (q.length === 0) return { synced: 0, remaining: 0 };
  let synced = 0;
  const remaining = [];
  for (const payload of q) {
    try {
      await api.post("/checkout", payload);
      synced++;
    } catch (e) {
      // 4xx = permanent rejection -> drop; network/5xx -> keep for retry
      if (e?.response && e.response.status >= 400 && e.response.status < 500) synced++;
      else remaining.push(payload);
    }
  }
  setQueue(remaining);
  return { synced, remaining: remaining.length };
}
